import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Animated, Dimensions, Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import MapView, { Marker } from 'react-native-maps'
import { PROVIDER_GOOGLE } from 'react-native-maps'
import { getLocation } from '../appBar/context/LocationContext'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { Feather } from '@expo/vector-icons'
import { schedulesServices } from '../../../database/schedules.database'
import { distanceInMeters } from '../customUtils/calculateDistance'
import { StoreItem } from './StoreItem'
import { CampaignStatus } from './StatusTagsStores'
import theme from '../../../theme'
import styles from './MapScreenStyles'
import { Loader } from '../customUtils/Components/Loader'
import { STORE_STATUS } from './constants/constants.stores'
const width = Dimensions.get('window').width
const height = Dimensions.get('window').height
export const MapScreen = ({ route }) => {
    const { userLat, userLng, setUserLat, setUserLng } = getLocation()
    const { selectedScheduleID, campaign_schedule_free, campaignSteps } = route.params
    const [stores, setStores] = useState([])
    const [markers, setMarkers] = useState([])
    const [visibleMarkers, setVisibleMarkers] = useState([])
    const navigation = useNavigation()
    const [viewedItemIndex, setViewedItemIndex] = useState(0)
    const [currentStore, setCurrentStore] = useState(null)
    // const scrollX = useRef(new Animated.Value(0)).current
    const scrollX = useRef(new Animated.Value(0)).current
    const deviceWidth = Dimensions.get('window').width
    const [currentIndex, setCurrentIndex] = useState(0)
    const mainViewRef = useRef(null)

    const [isLoading, setisLoading] = useState(true)
    const mapRef = useRef(null)

    // let initialCamera = (Camera = {
    //     center: {
    //         latitude: userLat,
    //         longitude: userLng,
    //     },
    //     heading: 0,
    //     pitch: 0,
    //     zoom: 16,
    // })

     let initialCamera = {
        center: {
            latitude: userLat,
            longitude: userLng,
        },
        heading: 0,
        pitch: 0,
        zoom: 16,
     }
    // useEffect(() => {
    //     getStores()
    // }, [])

    useFocusEffect(
        React.useCallback(() => {
            const fetch = async () => {
                await getStores()
            }
            fetch()
        }, [])
    )

    const getStores = async () => {
        console.log('====================================')
        console.log('estoy en el get stores del mapaaa')
        console.log('====================================')
        try {
            await schedulesServices
                .getStoresFromSchedule(0, 0, selectedScheduleID, -1, userLat, userLng, 5000, campaign_schedule_free)
                .then((allStores) => {
                    allStores.forEach((store) => {
                        store.distance = distanceInMeters(userLat, userLng, store.lat, store.lng)
                    })
                    console.log('ALL', allStores.length)

                    let markers = allStores.map((store) => {
                        return {
                            _id: store._id,
                            lat: store.lat,
                            lng: store.lng,
                            name: store.name,
                            color: getColorPin(store.campaign_status ?? 0),
                            status: store.campaign_status,
                            incidence_answer: store.incidence_answer
                        }
                    })
                    // .slice(0, 150)
                    setStores(allStores)
                    setMarkers(markers)
                    setisLoading(false)
                    // console.log('58 ---- markers.length: ', markers)
                })
        } catch {}
    }
    const onClickGoStore = (store) => {
        navigation.navigate('StoreDetail', {
            storeID: store._id,
            forms: store.forms,
            scheduleID: selectedScheduleID,
            steps: campaignSteps,
            forms_relevant: store.forms_relevant,
            forms_advances: store.forms_advances,
            distance: store.distance ?? 0,
            store_status: store.campaign_status,
            incidence_answer: store.incidence_answer
        })
    }

    const getItemLayout = (data, index) => ({
        length: deviceWidth,
        offset: deviceWidth * index,
        index,
    })

    const goToAddStores = () => {
        navigation.navigate('AddStores')
    }
    const onItemViewedChange = useCallback(
        (data) => {
            const isVisible = data?.changed[0]?.isViewable || false
            const item = data?.changed[0]?.item
            // let newCamera = (Camera = {
            //     center: {
            //         latitude: item.lat,
            //         longitude: item.lng,
            //     },
            //     heading: 0,
            //     pitch: 0,
            //     zoom: 16,
            // })

            let newCamera = {
                center: {
                    latitude: item.lat,
                    longitude: item.lng,
                },
                heading: 0,
                pitch: 0,
                zoom: 16,
            }
            setCurrentStore(newCamera)
        },
        [setViewedItemIndex],
    )
    const COLOR_BLACK = theme.colors.colorPending
    const COLOR_RED = 'red'

    const getColorPin = (status) => {
        switch (status) {
            case CampaignStatus.STATUS_FORM_PENDING:
                return theme.colors.colorPending
            case CampaignStatus.STATUS_FORM_APPROVED:
                return theme.colors.colorApproved
            case CampaignStatus.STATUS_FORM_PENDING_MODERATION:
                return '#ff002f'
            case CampaignStatus.STATUS_FORM_REFUSED:
                return '#ff002f'
            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                return '#0000ff'
            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                return '#ffffff'
            case STORE_STATUS.INCIDENCE_REPORTED_CLOSE:
                return COLOR_BLACK
            case STORE_STATUS.INCIDENCE_REPORTED:
                return COLOR_RED
            case STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE:
                return COLOR_RED
            default:
                return null
        }
    }
    useEffect(() => {
        const listener = scrollX.addListener(({ value }) => {
            const index = Math.round(value / deviceWidth)
            setCurrentIndex(index)
            // onPageChange(index === medias.length - 1)
        })

        return () => {
            scrollX.removeAllListeners()
            listener.remove()
        }
    }, [])
    const onScroll = Animated.event([{ nativeEvent: { contentOffset: { x: scrollX } } }], { useNativeDriver: true })

    const handleCameraChange = async () => {
        const camera = await mapRef.current?.getCamera()
        const data = await mapRef.current

        if (camera) {
            const { center, pitch, heading, altitude, zoom } = camera
            // Puedes calcular los límites visibles aquí
            updateVisibleMarkers(center, zoom, mapDimensions)
        }
    }
    const mapDimensions = { width: width, height: height }
    const updateVisibleMarkers = (center, zoom, mapDimensions) => {
        const bounds = calculateBounds(center, zoom, mapDimensions)
        const visibleMarkers = markers.filter((store) => isMarkerInBounds(store.lat, store.lng, bounds)).slice(0, 50)
        setVisibleMarkers(visibleMarkers)
    }

    useEffect(() => {
        const update = async () => {
            if (markers.length === 0 || !mapRef.current) return
            const camera = await mapRef.current?.getCamera()
            if (camera) {
                updateVisibleMarkers(camera.center, camera.zoom, mapDimensions)
            }
        }
        update()
    }, [markers])

    const calculateBounds = (center, zoom, mapDimensions) => {
        const { width, height } = mapDimensions

        const factor = 2 // Puedes ajustar este valor para ampliar más o menos el rango

        const latDelta = (360 / Math.pow(2, zoom)) * factor
        const lngDelta = (latDelta * (width / height)) / Math.cos((center.latitude * Math.PI) / 180)

        return {
            minLat: center.latitude - latDelta / 2,
            maxLat: center.latitude + latDelta / 2,
            minLng: center.longitude - lngDelta / 2,
            maxLng: center.longitude + lngDelta / 2,
        }
    }

    const isMarkerInBounds = (lat, lng, bounds) => {
        return lat >= bounds.minLat && lat <= bounds.maxLat && lng >= bounds.minLng && lng <= bounds.maxLng
    }

    if (isLoading) {
        return <Loader />
    }
    return (
        <>
            <View style={styles.container}>
                <MapView
                    ref={mapRef}
                    onRegionChangeComplete={handleCameraChange}
                    provider={PROVIDER_GOOGLE}
                    showsUserLocation={true}
                    followsUserLocation={true}
                    initialCamera={initialCamera}
                    camera={currentStore}
                    style={styles.map}
                >
                    {visibleMarkers.length > 0 &&
                        !isLoading &&
                        visibleMarkers.map((marker) => (
                            <Marker
                                // draggable
                                key={`${marker._id}-${marker.color}`}
                                coordinate={{
                                    latitude: marker.lat,
                                    longitude: marker.lng,
                                }}
                                title={marker.name}
                                pinColor={marker.color}
                                onCalloutPress={(e) => console.log('onCalloutPress', e)}
                                onPress={(e) => {
                                    let selectedIndex = stores.findIndex((store) => store._id === marker._id)

                                    if (selectedIndex !== -1) {
                                        let offset = Math.round(selectedIndex * deviceWidth)
                                        mainViewRef.current?.scrollToOffset({ offset: offset, animated: true })
                                    }
                                }}
                            />
                        ))}
                </MapView>
            </View>

            {!isLoading && (
                <View style={styles.cardContainer}>
                    <View style={styles.card}>
                        {/* <TouchableOpacity onPress={() => goToAddStores()}>
                            <Image style={[styles.image, styles.marginBottom]} source={require('../../../assets/add_store.png')} />
                        </TouchableOpacity> */}
                        <TouchableOpacity onPress={() => setCurrentStore(initialCamera)}>
                            <Image style={styles.image} source={require('../../../assets/location.png')} />
                        </TouchableOpacity>
                    </View>
                    {/* Al superar x item al scrollear, se suma un pequeño margen debajo al Animated.FlatList, no al item hijo */}
                    <Animated.FlatList
                        ref={mainViewRef}
                        data={stores}
                        style={styles.flatList}
                        pagingEnabled
                        horizontal={true}
                        getItemLayout={getItemLayout}
                        bounces={false}
                        keyExtractor={(item) => item._id}
                        renderItem={({ item: store }) => (
                            <View style={styles.containerStoreItem}>
                                <StoreItem key={store._id} store={store} onClickGoStore={onClickGoStore} />
                            </View>
                        )}
                        showsHorizontalScrollIndicator={false}
                        viewabilityConfig={{
                            waitForInteraction: false,
                            itemVisiblePercentThreshold: 80,
                            // minimumViewTime: 1000,
                        }}
                        onViewableItemsChanged={onItemViewedChange}
                    />
                </View>
            )}
        </>
    )
}
